module.exports = __webpack_public_path__ + "0b3250beef58285b3b412589914f9bde.svg";